export default __webpack_public_path__ + "static/media/global_logo.1c3a24f8.png";